import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Loader2, Palette, Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLanguage } from '@/contexts/LanguageContext';
import { SketchPicker } from 'react-color';

interface AddCategoryFormProps {
  onSubmit: (name: string, color: string, paymentTypeStudent: number, paymentTypeTeacher: number, pricesStudent: Record<string, number>, pricesTeacher: Record<string, number>) => void;
  onCancel: () => void;
}

const AddCategoryForm: React.FC<AddCategoryFormProps> = ({ onSubmit, onCancel }) => {
  const [name, setName] = useState('');
  const [color, setColor] = useState('#FFFFFF');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const isMobile = useIsMobile();
  const { t } = useLanguage();
  const [paymentTypeStudent, setPaymentTypeStudent] = useState<number>(1);
  const [paymentTypeTeacher, setPaymentTypeTeacher] = useState<number>(1);

  const [pricesStudent, setPricesStudent] = useState<Record<string, number>>({
    price_1: 0,
    price_2: 0,
    price_3: 0,
    price_4: 0,
    price_5: 0,
    price_6: 0,
    price_7: 0,
    price_8: 0,
    price_9: 0,
    price_10: 0,
    price_11: 0,
    price_12: 0,
    price_13: 0,
    price_14: 0,
    price_15: 0,
    price_16: 0,
    price_17: 0,
    price_18: 0,
    price_19: 0,
    price_20: 0,
    price_su: 0,
    price_fix: 0
  });

  const [pricesTeacher, setPricesTeacher] = useState<Record<string, number>>({
    price_1: 0,
    price_2: 0,
    price_3: 0,
    price_4: 0,
    price_5: 0,
    price_6: 0,
    price_7: 0,
    price_8: 0,
    price_9: 0,
    price_10: 0,
    price_11: 0,
    price_12: 0,
    price_13: 0,
    price_14: 0,
    price_15: 0,
    price_16: 0,
    price_17: 0,
    price_18: 0,
    price_19: 0,
    price_20: 0,
    price_su: 0,
    price_fix: 0
  });

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (color: { hex: string }) => {
    setColor(color.hex);
  };

  const handlePriceChange = (key: string, value: number, isStudent: boolean) => {
    if (isStudent) {
      setPricesStudent(prev => ({
        ...prev,
        [key]: value
      }));
    } else {
      setPricesTeacher(prev => ({
        ...prev,
        [key]: value
      }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      setIsSubmitting(true);
      onSubmit(name.trim(), color, paymentTypeStudent, paymentTypeTeacher, pricesStudent, pricesTeacher);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col relative h-full">
      <div className="flex flex-col gap-2">
        <ScrollArea className={isMobile ? 'max-h-[calc(100vh-100px)] pr-4 pb-20' : 'max-h-[calc(70vh-100px)] pr-4'}>
          <div className="space-y-4 pb-4">
            {<div>
              <Label htmlFor="new-category-name">{t('categories.name')}</Label>
              <Input
                id="new-category-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder=""
                autoFocus
              />
            </div>
            /*
            <div className='pt-2 pb-2'>
              <Label htmlFor="new-category-color">{t('categories.color')}</Label>
              <div className="flex items-center gap-2 pt-2">
                {isMobile ? (
                  <Input
                    id="new-category-color"
                    type="color"
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    className="w-10 h-10 p-1 rounded-md cursor-pointer"
                  />
                ) : (
                  <>
                    <div
                      onClick={handleClick}
                      style={{
                        width: '42px',
                        height: '42px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: color === '#FFFFFF' ? 'transparent' : color,
                      }}
                    >
                      {color === '#FFFFFF' ? <Palette size={20} /> : null}
                    </div>
                    <div
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: color,
                        border: '1px solid #ccc',
                      }}
                    />
                    {displayColorPicker ? (
                      <div style={{ position: 'absolute', zIndex: 50, top: '8px', right: '0px', bottom: '0px', left: '8px' }}>
                        <div style={{ position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }} onClick={handleClose} />
                        <SketchPicker color={color} onChange={handleChange} />
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>*/}
            <Tabs defaultValue="teacher" className="space-y-4">
              <TabsList>
                <TabsTrigger value="teacher">{t('categories.tabTeachers')}</TabsTrigger>
                <TabsTrigger value="student">{t('categories.tabStudents')}</TabsTrigger>
              </TabsList>
              <TabsContent value="student">
                <div className="space-y-2 pb-3">
                  <Label>{t('categories.paymentType')}</Label>
                  <RadioGroup
                    value={paymentTypeStudent.toString()}
                    onValueChange={(value) => setPaymentTypeStudent(parseInt(value))}
                    className="flex flex-col space-y-1"
                  >
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="0" id="hourly-rate-student" />
                      <Label htmlFor="hourly-rate-student">{t('categories.hourly_rate')}</Label>
                      <Popover>
                        <PopoverTrigger asChild>
                          <span className="font-medium flex items-center gap-1">
                            <Info className="h-3.5 w-3.5 text-muted-foreground" />
                          </span>
                        </PopoverTrigger>
                        <PopoverContent className="w-48 p-2 text-xs">
                          {t('categories.hourly_rate_explication')}
                        </PopoverContent>
                      </Popover>
                    </div>
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="1" id="fixed-price-student" />
                      <Label htmlFor="fixed-price-student">{t('categories.fixed_price')}</Label>
                      <Popover>
                        <PopoverTrigger asChild>
                          <span className="font-medium flex items-center gap-1">
                            <Info className="h-3.5 w-3.5 text-muted-foreground" />
                          </span>
                        </PopoverTrigger>
                        <PopoverContent className="w-48 p-2 text-xs">
                          {t('categories.fixed_price_explication')}
                        </PopoverContent>
                      </Popover>
                    </div>
                  </RadioGroup>
                </div>

                <label className="flex items-center gap-1 my-5">
                  <Info className="h-4 w-4 text-muted-foreground" />
                  <span className="text-xs">{t('categories.StudentPriceExplanation')}</span>
                </label>

                {paymentTypeStudent === 0 ? (
                  <div className="space-y-3">
                    <Label>{t('categories.price_per_student')} ({t('categories.hourly')})</Label>
                    <div className="grid grid-cols-2 gap-2">
                      {Array.from({ length: 20 }, (_, i) => i + 1).map((num) => (
                        <div key={`price_${num}`} className="space-y-1">
                          <Label htmlFor={`price_${num}_student_hourly`} className="text-xs">
                            {num} {t('students.student')}{num > 1 ? 's' : ''}
                          </Label>
                          <Input
                            id={`price_${num}_student_hourly`}
                            type="number"
                            value={pricesStudent[`price_${num}`]}
                            onChange={(e) => handlePriceChange(`price_${num}`, parseFloat(e.target.value) || 0, true)}
                            onFocus={(e) => e.target.select()}
                            min="0"
                            step="0.01"
                          />
                        </div>
                      ))}
                      <div className="space-y-1">
                        <Label htmlFor="price_su_student_hourly" className="text-xs">{t('categories.more_than')} 20</Label>
                        <Input
                          id="price_su_student_hourly"
                          type="number"
                          value={pricesStudent.price_su}
                          onChange={(e) => handlePriceChange('price_su', parseFloat(e.target.value) || 0, true)}
                          onFocus={(e) => e.target.select()}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    <Label htmlFor="price_fix_student">{t('categories.fixed_price')}</Label>
                    <Input
                      id="price_fix_student"
                      type="number"
                      value={pricesStudent.price_fix}
                      onChange={(e) => handlePriceChange('price_fix', parseFloat(e.target.value) || 0, true)}
                      onFocus={(e) => e.target.select()}
                      min="0"
                      step="0.01"
                    />
                  </div>
                )}
              </TabsContent>
              <TabsContent value="teacher">
                <div className="space-y-2 pb-3">
                  <Label>{t('categories.paymentType')}</Label>
                  <RadioGroup
                    value={paymentTypeTeacher.toString()}
                    onValueChange={(value) => setPaymentTypeTeacher(parseInt(value))}
                    className="flex flex-col space-y-1"
                  >
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="0" id="hourly-rate-teacher" />
                      <Label htmlFor="hourly-rate-teacher">{t('categories.hourly_rate')}</Label>
                      <Popover>
                        <PopoverTrigger asChild>
                          <span className="font-medium flex items-center gap-1">
                            <Info className="h-3.5 w-3.5 text-muted-foreground" />
                          </span>
                        </PopoverTrigger>
                        <PopoverContent className="w-48 p-2 text-xs">
                          {t('categories.hourly_rate_explication')}
                        </PopoverContent>
                      </Popover>
                    </div>
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="1" id="fixed-price-teacher" />
                      <Label htmlFor="fixed-price-teacher">{t('categories.fixed_price')}</Label>
                      <Popover>
                        <PopoverTrigger asChild>
                          <span className="font-medium flex items-center gap-1">
                            <Info className="h-3.5 w-3.5 text-muted-foreground" />
                          </span>
                        </PopoverTrigger>
                        <PopoverContent className="w-48 p-2 text-xs">
                          {t('categories.fixed_price_explication')}
                        </PopoverContent>
                      </Popover>
                    </div>
                  </RadioGroup>
                </div>
                <label className="flex items-center gap-1 my-5">
                  <Info className="h-4 w-4 text-muted-foreground" />
                  <span className="text-xs">{t('categories.teacherPriceExplanation')}</span>
                </label>

                {paymentTypeTeacher === 0 ? (
                  <div className="space-y-3">
                    <Label>{t('categories.price_per_teacher')} ({t('categories.hourly')})</Label>
                    <div className="grid grid-cols-2 gap-2">
                      {Array.from({ length: 20 }, (_, i) => i + 1).map((num) => (
                        <div key={`price_${num}`} className="space-y-1">
                          <Label htmlFor={`price_${num}_teacher_hourly`} className="text-xs">
                            {num} {t('students.student')}{num > 1 ? 's' : ''}
                          </Label>
                          <Input
                            id={`price_${num}_teacher_hourly`}
                            type="number"
                            value={pricesTeacher[`price_${num}`]}
                            onChange={(e) => handlePriceChange(`price_${num}`, parseFloat(e.target.value) || 0, false)}
                            onFocus={(e) => e.target.select()}
                            min="0"
                            step="0.01"
                          />
                        </div>
                      ))}
                      <div className="space-y-1">
                        <Label htmlFor="price_su_teacher_hourly" className="text-xs">{t('categories.more_than')} 20</Label>
                        <Input
                          id="price_su_teacher_hourly"
                          type="number"
                          value={pricesTeacher.price_su}
                          onChange={(e) => handlePriceChange('price_su', parseFloat(e.target.value) || 0, false)}
                          onFocus={(e) => e.target.select()}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    <Label htmlFor="price_fix_teacher">{t('categories.fixed_price')}</Label>
                    <Input
                      id="price_fix_teacher"
                      type="number"
                      value={pricesTeacher.price_fix}
                      onChange={(e) => handlePriceChange('price_fix', parseFloat(e.target.value) || 0, false)}
                      onFocus={(e) => e.target.select()}
                      min="0"
                      step="0.01"
                    />
                  </div>
                )}
              </TabsContent>
            </Tabs>
          </div>
        </ScrollArea>
      </div>
      <div className={`flex gap-2 pt-4 mt-4 border-t ${
        isMobile
          ? 'fixed bottom-0 left-0 right-0 bg-gray-50 p-4 z-50 justify-center'
          : 'justify-end'
      }`}>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          {t('common.cancel')}
        </Button>
        <Button type="submit" disabled={!name.trim() || isSubmitting}>
          {isSubmitting ? (
            <span className="flex items-center">
              <Loader2 className="mr-1 h-3 w-3 animate-spin" />
              {t('common.processing')}
            </span>
          ) : (
            t('common.done')
          )}
        </Button>
      </div>
    </form>
  );
};

export default AddCategoryForm;
